import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../style.css';

function OurLocation() {
  return (
    <div className="page-wrapper">
      <Helmet>
        <title>Our Location | Culturlingua — Tlaquepaque, Jalisco, México</title>
        <meta name="description" content="Visit Culturlingua in Tlaquepaque, Jalisco. Discover the beauty of Mexico while learning Spanish." />
      </Helmet>

      <div className="page-hero">
        <div className="section-tag">Tlaquepaque, Jalisco</div>
        <h1>Our Location</h1>
        <p>Explore the wonders of Mexico while studying with us.</p>
      </div>

      <section style={{background:'var(--cream)', padding:'80px 48px'}}>
        <div style={{maxWidth:'1200px', margin:'0 auto'}}>

          <div className="cards-grid" style={{marginBottom:'60px'}}>
            {[
              { flag: '🇲🇽', title: 'Mexico', desc: 'Land of rich culture, delicious food, and breathtaking landscapes.', img: '/assets/mexico.jpg' },
              { flag: '🌵', title: 'Jalisco', desc: 'The birthplace of mariachi, tequila, and incredible traditions.', img: '/assets/jalisco.jpg' },
              { flag: '🎭', title: 'Tlaquepaque', desc: 'A magical town full of colorful streets, art, traditions, and vibrant life.', img: '/assets/tlaquepaque.jpg' },
            ].map(({ flag, title, desc, img }) => (
              <div className="modal-card" key={title}>
                <img src={img} alt={title} style={{width:'100%', height:'200px', objectFit:'cover', display:'block'}} />
                <div className="modal-card-body">
                  <div style={{fontSize:'2rem', marginBottom:'8px'}}>{flag}</div>
                  <h3>{title}</h3>
                  <p>{desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div style={{background:'white', borderRadius:'20px', overflow:'hidden', boxShadow:'0 4px 24px rgba(0,0,0,0.08)', marginBottom:'40px'}}>
            <div style={{padding:'32px 32px 0'}}>
              <div className="section-tag">Encuéntranos</div>
              <h2 className="section-headline" style={{fontSize:'1.6rem', marginBottom:'8px'}}>📍 Reforma 31, Tlaquepaque</h2>
              <p style={{color:'var(--muted)', marginBottom:'24px'}}>Jalisco, México — A steps away from El Parián</p>
            </div>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3733.790690850651!2d-103.31288652577223!3d20.637386701107793!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428b3b317ea78ef%3A0xa00c5f440c6b46b3!2sCulturlingua!5e0!3m2!1sen!2smx!4v1738696722222!5m2!1sen!2smx"
              width="100%" height="420"
              style={{border:0, display:'block'}}
              allowFullScreen loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          <div style={{textAlign:'center'}}>
            <Link to="/contacto" className="btn-glow">Contact Us →</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default OurLocation;
